import React from "react";

// --- ENHANCED DATA ---
const REQUESTS = [
  { 
    id: "EVT-2026-001", 
    type: "Royal Heritage Wedding", 
    city: "The Oberoi Udaivilas, Udaipur", 
    date: "Nov 15, 2026", 
    status: "Planning Phase", 
    nextMilestone: "Menu Tasting & Selection",
    manager: "Anjali Singh", 
    managerAvatar: "https://ui-avatars.com/api/?name=Anjali+Singh&background=0B1F33&color=fff",
    progress: 35, 
    totalSteps: 8,
    currentStep: 3,
    updates: 2 
  },
  { 
    id: "EVT-2026-002", 
    type: "Annual Corporate Gala", 
    city: "Jio World Centre, Mumbai", 
    date: "Aug 20, 2026", 
    status: "Execution Ready", 
    nextMilestone: "Final Soundcheck",
    manager: "Vikram Rathore", 
    managerAvatar: "https://ui-avatars.com/api/?name=Vikram+Rathore&background=0B1F33&color=fff",
    progress: 90, 
    totalSteps: 5,
    currentStep: 5,
    updates: 0 
  }
];

const RequestsView = ({ onSelectEvent }) => (
    <div className="animate-fade-in-up font-sans text-[#0B1F33]">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
            <div>
                <h2 className="text-2xl font-black text-[#0B1F33]">Event Projects</h2>
                <p className="text-xs text-gray-500 font-medium mt-1">Track progress and approve milestones</p>
            </div>
            <button className="text-xs font-bold text-[#D4AF37] uppercase tracking-wider hover:underline flex items-center gap-1">
                Archived <span className="material-symbols-outlined text-sm">inventory_2</span>
            </button>
        </div>

        <div className="grid gap-6">
            {REQUESTS.map((req) => (
                <div 
                    key={req.id} 
                    onClick={() => onSelectEvent(req)} 
                    className="group bg-white rounded-[2rem] p-0 border border-gray-100 shadow-sm hover:shadow-xl hover:shadow-[#0B1F33]/5 transition-all duration-300 cursor-pointer overflow-hidden relative"
                >
                    {/* Hover Accent Line */}
                    <div className="absolute top-0 left-0 w-1 h-full bg-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity"></div>

                    <div className="p-6 md:p-8">
                        <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
                            
                            {/* Left: Event Info */}
                            <div className="flex-1">
                                <div className="flex items-center gap-3 mb-2">
                                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{req.id}</span>
                                    <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${req.progress === 100 ? 'bg-green-50 text-green-600' : 'bg-[#0B1F33]/5 text-[#0B1F33]'}`}>
                                        {req.status}
                                    </span>
                                </div>
                                <h3 className="text-2xl font-black text-[#0B1F33] mb-1 group-hover:text-[#D4AF37] transition-colors">
                                    {req.type}
                                </h3>
                                <div className="flex items-center gap-4 text-sm text-gray-500 font-medium">
                                    <span className="flex items-center gap-1"><span className="material-symbols-outlined text-sm">calendar_month</span> {req.date}</span>
                                    <span className="flex items-center gap-1"><span className="material-symbols-outlined text-sm">location_on</span> {req.city}</span>
                                </div>
                            </div>

                            {/* Right: Manager Profile */}
                            <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-2xl border border-gray-100">
                                <img src={req.managerAvatar} alt={req.manager} className="w-10 h-10 rounded-full object-cover" />
                                <div>
                                    <p className="text-[10px] text-gray-400 uppercase font-bold tracking-wider">Lead Planner</p>
                                    <p className="text-sm font-bold text-[#0B1F33]">{req.manager}</p>
                                </div>
                                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center border border-gray-200 text-[#0B1F33] hover:text-[#D4AF37] transition-colors ml-2">
                                    <span className="material-symbols-outlined text-sm">chat</span>
                                </div>
                            </div>
                        </div>

                        {/* Middle: Milestone Tracker */}
                        <div className="mt-8">
                            <div className="flex justify-between items-end mb-2">
                                <div>
                                    <p className="text-[10px] font-bold text-[#D4AF37] uppercase tracking-wider mb-1">Up Next</p>
                                    <p className="text-sm font-bold text-[#0B1F33]">{req.nextMilestone}</p>
                                </div>
                                <span className="text-xs font-bold text-gray-400">Step {req.currentStep} / {req.totalSteps}</span>
                            </div>
                            
                            {/* Custom Progress Bar */}
                            <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden flex">
                                <div 
                                    className="h-full bg-gradient-to-r from-[#0B1F33] to-[#D4AF37] transition-all duration-1000 ease-out" 
                                    style={{ width: `${req.progress}%` }}
                                ></div>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Action Strip */}
                    <div className="bg-gray-50 px-6 py-4 flex justify-between items-center border-t border-gray-100 group-hover:bg-[#0B1F33] transition-colors duration-300">
                        <div className="flex items-center gap-2">
                            {req.updates > 0 && (
                                <span className="flex items-center gap-2 text-[10px] font-bold bg-red-50 text-red-500 px-3 py-1 rounded-full group-hover:bg-red-500 group-hover:text-white transition-colors">
                                    <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse"></span>
                                    {req.updates} New Updates
                                </span>
                            )}
                        </div>
                        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#0B1F33] group-hover:text-white transition-colors">
                            Open Project <span className="material-symbols-outlined text-sm">arrow_forward</span>
                        </span>
                    </div>

                </div>
            ))}
        </div>
    </div>
);

export default RequestsView;